module.exports = __webpack_public_path__ + "static/media/Montserrat-MediumItalic.3ebc1a21.ttf";